import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { getEnvironment } from '../lib/environment'

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

function RouteComponent() {
  useEffect(() => {
    const env = getEnvironment()
    let redirectUrl: string
    
    switch (env) {
      case 'production':
        redirectUrl = 'https://rom.roqua.nl'
        break
      case 'staging':
        redirectUrl = 'https://rom.roqua-staging.nl'
        break
      case 'development':
      case 'test':
        redirectUrl = 'http://rom.roqua.eu'
        break
      default:
        redirectUrl = 'https://rom.roqua.nl'
    }
    
    window.location.href = redirectUrl
  }, [])

  return <div>Redirecting...</div>
}
